export function accordion() {
    $(".accordion").on("click", "a", function (e) {
        let accordion = $(this).parents(".accordion");
        let parent = $(this).parent().parent(".item");
        if (parent.hasClass("active")) {
            parent.removeClass("active").find(".info").slideUp(350);
        } else {
            accordion.find(".item").removeClass("active").find(".info").slideUp(350);
            parent.addClass("active").find(".info").slideDown(350);
        }
        e.preventDefault();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js